<template>
  <div class="wrap1">
    <h2 class="common-title">
      <i class="el-icon-arrow-left icon" @click="handlerBack"></i>
      {{ $t('i18n.5a6653a1d4ea4108ab13f868622bd90a') }}
    </h2>
    <div class="wrap1-box">
      <div class="wrap1-tip">
        <i class="el-icon-info icon-info"></i>
        <p>{{ $t('i18n.4c460011353743cebd42150ecacb4a2c') }}</p>
        <p>{{ $t('i18n.10ba60c8a69e48abb2f4870b1f72830a') }}</p>
      </div>
      <div class="search">
        <div class="search-left">
          <!-- 搜索人 -->
          <staff-search class="search-input" comment="comment" size="small" @change="staffChange" />
          <el-button size="small" type="primary" @click="handleSubmit">{{ $t('69') }}</el-button>
        </div>
        <div class="search-center"></div>
        <div class="search-right">
          <!-- 批量删除 -->
          <el-button size="small" type="danger" :disabled="!multipleSelection.length" @click="batchDelete">{{
            $t('payroll_wage_21')
          }}</el-button>
          <!--添加调薪人员 -->
          <el-button size="small" @click="addStaff">{{ $t('i18n.df315ff2392943d8a8a7f84e2b2adf0c') }}</el-button>
          <!--批量导入 -->
          <el-button size="small" type="primary" @click="handleImport">{{
            $t('i18n.3353c28e68de448481713c81c1849594')
          }}</el-button>
        </div>
      </div>
      <el-form ref="form" :model="allTableData">
        <el-table
          :data="tableData"
          style="width: 100%"
          :max-height="tableHeight"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="60"> </el-table-column>
          <el-table-column
            v-for="item in allTableData.columns"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width || 'auto'"
            :fixed="item.fixed"
          >
            <template slot-scope="{ row, $index }">
              <template v-if="item.edit">
                <template v-if="item.type === 'picker'">
                  <!-- 调薪生效时间 -->
                  <el-form-item
                    :prop="`list.${$index}.${item.prop}`"
                    :rules="[{ required: true, message: '', trigger: 'change' }]"
                  >
                    <el-date-picker
                      size="small"
                      type="date"
                      style="width: auto"
                      value-format="yyyy-MM-dd"
                      clearable
                      v-model="row[item.prop]"
                      :placeholder="$t('878')"
                      :picker-options="pickerOptions(row)"
                    >
                    </el-date-picker>
                  </el-form-item>
                </template>
                <!-- 调薪原因 -->
                <template v-if="item.type === 'select'" prop="email">
                  <el-form-item
                    :prop="`list.${$index}.${item.prop}`"
                    :rules="[{ required: true, message: '', trigger: 'change' }]"
                  >
                    <el-select size="small" v-model="row[item.prop]" clearable>
                      <el-option v-for="(item, key) in reasonTypeList" :key="item" :label="item" :value="key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <!-- 输入框 -->
                <template v-if="item.type === 'input'">
                  <el-form-item>
                    <el-input size="small" v-model="row[item.prop]" :placeholder="$t('90')"></el-input>
                  </el-form-item>
                </template>
                <!-- 输入框 number -->
                <template v-if="item.type === 'number'">
                  <el-form-item
                    :prop="`list.${$index}.${item.prop}`"
                    :rules="[
                      { required: true, validator: validatePass, prop: item.prop, message: '', trigger: 'blur' }
                    ]"
                  >
                    <el-input-number
                      :precision="2"
                      size="small"
                      :min="0"
                      v-model="row[item.prop]"
                      placeholder="0.00"
                    ></el-input-number>
                  </el-form-item>
                </template>
              </template>
              <template v-else>
                {{ row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n.cb645ef1e11b45d3822b8f20f85112cd')" min-width="190" fixed="right">
            <template slot-scope="{ row, $index }">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :show-file-list="false"
                :headers="baseHeaders"
                :before-upload="beforeUploadHandle"
                :on-success="successHandle"
                :on-error="errorHandle"
                :on-exceed="exceedHandle"
                :file-format="fileFormat"
              >
                <el-button type="text" @click="handleUpload($index)">{{
                  row.update_reason_file
                    ? $t('i18n.595811d833074ec58d035dc69bcb209e')
                    : $t('i18n.14012c4342484c66810e8b7df8e4c823')
                }}</el-button>
              </el-upload>
              <el-button v-if="row.update_reason_file" type="text" @click="handleClear(row, $index)">{{
                $t('i18n.61c27f38500c4099adf31401235590bc')
              }}</el-button>
              <el-button v-if="row.update_reason_file" type="text" @click="handleCheck(row, $index)">{{
                $t('i18n.a8c5e8d713e84d478db1b6dda1bf4a06')
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('70')" min-width="190" fixed="right">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="handleCacle(row, $index)">{{ $t('65') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row class="flex-btn">
        <!-- 取消 -->
        <el-button size="small" @click="handlerBack">{{ $t('66') }}</el-button>
        <!-- 导入调薪数据 -->
        <el-button :disabled="!tableData.length" size="small" type="primary" @click="onSave">{{
          $t('i18n.0a408a212a00470db2e9be402ec268b6')
        }}</el-button>
      </el-row>
      <!-- 批量导入 -->
      <batch-upload ref="batchUpload" @doSubmit="uploadSubmit" />
      <organization
        v-if="orgVisible"
        ref="organization"
        :params="{ settlement_type: 1 }"
        :visible.sync="orgVisible"
        :defaultDepatment="[]"
        :defaultEmployess="[]"
        @onConfirm="getSelectNode"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import organization from '_c/organization'
import staffSearch from '_c/staff-search'
import batchUpload from '_c/batch-upload'
import { tableConfig } from './components/config.js'
import { baseHeaders } from 'util/axios-request'
import {
  getBatchUpdateSalaryList,
  updateSalaryReasonTypeList,
  saveBatchUpdateSalaryData, // 批量调薪-保存调薪数据
  downloadBatchUpdateSalaryTpl // 下载模板
} from '@/api/payroll'

const baseURL = process.env.VUE_APP_BASE_API
export default {
  components: {
    staffSearch,
    batchUpload,
    organization
  },
  data() {
    return {
      baseHeaders: baseHeaders(),
      uploadUrl: baseURL + '/web/tool/upload_file',
      orgData: {
        index: '',
        department_ids: [],
        staff_ids: []
      },
      orgVisible: false,
      reasonTypeList: {}, // 调薪原因
      allTableData: this.$s.get('salaryBatch') || { list: [], columns: {} },
      tableData: [],
      multipleSelection: [],
      staffId: '',
      initFiles: [],
      pickerOptions: () => {},
      fileFormat: ['.pdf', '.jpg', '.jpeg', '.png'],
      validatePass(rule, value, callback) {
        const { prop } = rule
        if (prop !== 'salary_basic_later' && Number(value) >= 0) {
          return callback()
        }
        if (Number(value) > 0) {
          return callback()
        }
        callback(new Error(''))
      }
    }
  },
  created() {
    this.getReasonTypeList()
    this.orgVisible = !this.allTableData.list.length
    if (!this.orgVisible) this.handleTableData(this.allTableData)
    // 可选择对应员工入职日期以后日期
    this.$nextTick(() => {
      this.pickerOptions = function (row) {
        return {
          disabledDate(time) {
            return time.getTime() < new Date(row.hire_date).getTime()
          }
        }
      }
    })
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 177
    }
  },
  methods: {
    handlerBack() {
      this.$router.go(-1)
    },
    // 获取数据
    getSelectNode(val) {
      this.orgData.department_ids = val.depIds
      this.orgData.staff_ids = val.staffIds
      getBatchUpdateSalaryList({
        department_ids: this.orgData.department_ids,
        staff_ids: this.orgData.staff_ids
      }).then(res => {
        this.handleTableData(res.data || [])
      })
    },
    // 处理表头数据
    handleColumn({ columns }) {
      const arr = []
      tableConfig.forEach(item => {
        if (columns[item.prop]) {
          arr.push(item)
          delete columns[item.prop]
        }
      })
      if (Array.isArray(columns)) return
      const keys = Object.keys(columns)
      keys.forEach(item => {
        const obj = { edit: false, type: '', label: columns[item], prop: item, width: 200 }
        // 调薪后可编辑
        if (item.indexOf('later') !== -1) {
          obj.edit = true
          obj.type = 'number'
        }
        // 操作原因
        if (['update_reason_type', 'salary_update_start_date', 'update_reason_remark'].includes(item)) {
          obj.edit = true
          obj.type = 'input'
          if (item === 'update_reason_type') obj.type = 'select'
          if (item === 'salary_update_start_date') obj.type = 'picker'
        }
        arr.push(obj)
      })
      return arr
    },
    // 处理表格数据
    handleTableData(val) {
      const keys = Object.keys(this.allTableData.columns)
      if (!keys.length) {
        this.allTableData.columns = this.handleColumn(val)
      }
      // 列表去重
      const obj = {}
      this.allTableData.list.forEach(item => {
        obj[item.staff_phone] = item
      })
      if (val.list && val.list.length) {
        val.list.forEach(item => {
          if (obj[item.staff_phone]) {
            obj[item.staff_phone] = Object.assign({}, obj[item.staff_phone], item)
          } else {
            obj[item.staff_phone] = item
          }
          const keys = Object.keys(obj[item.staff_phone])
          keys.forEach(key => {
            if (key.indexOf('later') !== -1) {
              const str = String(obj[item.staff_phone][key])
              obj[item.staff_phone][key] = str ? obj[item.staff_phone][key] : undefined
            }
          })
        })
      }
      this.allTableData.list = Object.values(obj)
      this.tableData = this.allTableData.list
      this.$s.set('salaryBatch', this.allTableData)
    },
    // 调薪原因
    getReasonTypeList() {
      updateSalaryReasonTypeList().then(res => {
        if (res && res.code === 1) {
          this.reasonTypeList = res.data
        }
      })
    },
    // 添加调薪人员
    addStaff() {
      this.orgVisible = true
    },
    // 搜索
    staffChange(val) {
      this.staffId = val.staff_id
    },
    handleSubmit() {
      if (!this.staffId) {
        this.tableData = this.allTableData.list
        return
      }
      const data = this.allTableData.list.filter(item => item.staff_info_id === this.staffId)
      this.tableData = data
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量删除
    batchDelete() {
      this.$confirm(
        this.$t('i18n.9ca200c0512c4453bfd78626d3943fc6', { x: this.multipleSelection.length }),
        this.$t('229'),
        {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        }
      )
        .then(() => {
          this.handleDelete(this.multipleSelection)
        })
        .catch(() => {})
    },
    handleDelete(data) {
      const obj = {}
      data.forEach(item => (obj[item.staff_info_id] = item))
      const list = this.allTableData.list.filter((item, index) => !obj[item.staff_info_id])
      this.allTableData.list = list
      this.$s.set('salaryBatch', this.allTableData)
      // 批量删除后对应搜索字段重新筛选数据
      this.handleSubmit()
    },
    // 批量导入
    handleImport() {
      const ids = []
      this.allTableData.list.forEach(item => {
        ids.push(item.staff_info_id)
      })
      const data = {
        title: this.$t('i18n.ea76732a9cb443b3a964e602babf84bc'),
        list: {
          1: {
            name: this.$t('bulkImport'),
            label: '1',
            tip: this.$t('i18n.d47430700982442fa686294f0a5bd7b0'),
            download: this.$t('i18n.18c86f2f267c4f01b9d80462a4281215'),
            download_text: this.$t('1373'),
            download_api: downloadBatchUpdateSalaryTpl,
            upload: this.$t('39'),
            upload_text: this.$t('52'),
            upload_tip: this.$t('i18n.f502f233c5d445df93392a7ab3e8dafe', { type: '.xls、.xlsx' }),
            upload_api: 'web/payroll_staff/uploadBatchUpdateSalaryData',
            type: '2',
            emit: true,
            query: {
              staff_ids: ids,
              department_ids: []
            }
          }
        }
      }
      this.$refs.batchUpload.init(data)
    },
    uploadSubmit(val) {
      this.handleTableData(val)
    },
    // 导入调薪数据
    onSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          saveBatchUpdateSalaryData({ list: this.allTableData.list }).then(res => {
            if (!res.data) return
            const state = Number(res.data.all_count) === Number(res.data.success_count)
            const list = []
            this.$confirm(
              state
                ? this.$t('i18n.20291e5ae8624c478bbc98633071f7dc', { count: res.data.all_count })
                : `<p>${this.$t('i18n.6b0e6f58421541969c53cbf845346d03', { count: Number(res.data.all_count) })}</p>
                <p>${this.$t('i18n.921bc9d492884b4d92ab6afdc6437f77', { success: Number(res.data.success_count) })}</p>
                <p>${this.$t('i18n.a615efc4d78e4002abb94bcfac8ff6ca', { fail: Number(res.data.error_count) })}</p>
                <p>${this.$t('i18n.3b20b154f8ac4687a57c915c76b03033')}</p>`,
              state
                ? this.$t('i18n.f948eab8d5c74951b0d2cbb36c174872')
                : this.$t('i18n.b92ec430413b4d529caf19b3df3124b6'),
              {
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                confirmButtonText: state ? this.$t('131') : this.$t('i18n.b92ec430413b4d529caf19b3df3124b6'),
                cancelButtonText: this.$t('66'),
                closeOnClickModal: false,
                type: state ? 'success' : 'warning'
              }
            )
              .then(() => {
                if (!state) window.open(res.data.file_path)
              })
              .catch(() => {})
              .finally(() => {
                // 有错误数据展示，没有返回上一页
                if (state) {
                  this.handlerBack()
                } else {
                  res.data.error_msg.forEach((item, index) => {
                    if (!Number(item.state)) list.push(this.allTableData.list[index])
                  })
                  this.allTableData.list = list
                  this.tableData = this.allTableData.list
                  this.$s.set('salaryBatch', this.allTableData)
                }
              })
          })
        }
      })
    },
    // 上传失败 err, file, fileList
    errorHandle(err) {
      let msg = JSON.parse(err['message'])
      this.$message.error(msg.message)
      throw err
    },
    handleClear(row) {
      row.update_reason_file = ''
    },
    handleCheck(row) {
      window.open(row.update_reason_file, '_blank')
    },
    handleUpload(index) {
      this.orgData.index = index
    },
    // 上传成功+
    successHandle(res) {
      this.$message.success(this.$t('818'))
      const index = this.orgData.index
      this.$set(this.allTableData.list[index], 'update_reason_file', res.data.object_url || '')
      this.$s.set('salaryBatch', this.allTableData)
    },
    exceedHandle() {
      this.$message.error(
        this.$t('payroll_management_58', {
          fileLimit: 1
        })
      )
    },
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      }
    },
    handleCacle(row) {
      this.$confirm(this.$t('i18n.7aaa531b06b648fbb72682f992c0db5d'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(() => {
          this.handleDelete([row])
        })
        .catch(() => {})
    }
  },
  beforeDestroy() {
    // 删除本地存储的salaryBatch
    this.$s.remove('salaryBatch')
  }
}
</script>
<style lang="scss" scoped>
.wrap1 {
  &-box {
    padding-top: 24px;
  }
  .search {
    display: flex;
    flex-wrap: wrap;
    .search-center {
      flex: 1;
    }
    .search-left {
      padding-bottom: 16px;
    }
    .search-right {
      padding-bottom: 16px;
      .el-button {
        margin-left: 16px;
      }
    }

    .search-input {
      min-width: 320px;
      margin: 0 16px;
    }
  }
  .el-form-item {
    margin: 0;
    /deep/ .el-input-number {
      &__decrease,
      &__increase {
        display: none;
      }
    }
  }
}
.icon {
  margin-right: 24px;
  cursor: pointer;
}
</style>
